import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

/**
 * QueryClient configuration for Admin Dashboard
 * 
 * Default settings:
 * - staleTime: 30s (data considered fresh)
 * - cacheTime: 5m (data kept in cache after unmount)
 * - retry: 1 (retry failed requests once)
 * - refetchOnWindowFocus: false (don't refetch on tab focus)
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      gcTime: 5 * 60 * 1000, // 5 minutes (formerly cacheTime in v4)
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0, // Don't retry mutations
    },
  },
});

export default function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
